import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Form from "../Firestore/Form";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../_layout";

import { observer, Observer } from "mobx-react";

import { MaterialIcons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Octicons } from "@expo/vector-icons";

import { v4 as uuidv4 } from "uuid";
import Question from "../Firestore/Question";
import IconEmptyView from "../Components/IconEmptyView";
import ClientWeekStatusText from "../Components/ClientWeekStatusText";

import { useTranslation } from "react-i18next";
import SearchBar from "../Components/SearchBar";

const AddFormView = observer(({ isVisible, onClose, form, coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const predefinedText = form ? form.name : t("newForm-string");

  const text = form ? "editForm-string" : "createForm-string";

  useEffect(() => {
    coach.initAddFormView(form);
    coach.setProperty("searchTermClientsInForm", "");
  }, [coach]);

  const cancel = () => {
    coach.resetAuxForm();
    coach.setProperty("searchTermClientsInForm", "");
    if (form) {
      form.setProperty("isSelected", false);
    }
    onClose();
  };

  const HeaderButtons = () => {
    const Buttons = observer(({ bool }) => {
      const text = bool ? "save-string" : "cancel-string";
      const Save = () => {
        coach.addOrEditForm(form);
        onClose();
      };
      const [isHovered, setIsHovered] = useState(false);

      return bool ? (
        <TouchableOpacity
          onPress={Save}
          disabled={!coach.canSaveForm}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: Colors.bubbleColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: Colors.bubbleColor,
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              opacity: !coach.canSaveForm ? 0.5 : isHovered ? 0.7 : 1,
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: Colors.whiteColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={cancel}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: "red",
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              marginHorizontal: 10,
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: isHovered ? "white" : Colors.redColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",

          marginBottom: screenSize != "large" ? 8 : 16,
        }}
      >
        <Buttons bool={false} />
        <Buttons bool={true} />
      </View>
    );
  };

  const ClientsList = observer(() => {
    const ClientRow = observer(({ client, index, isLast }) => {
      const isSelected = coach.formSelectedClients.includes(client);
      const select = () => {
        coach.selectClientForForm(client);
        coach.setProperty("searchTermClientsInForm", "");
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={select}
          style={{
            flexDirection: "row",
            flex: 1,
            paddingVertical: 8,
            paddingHorizontal: 12,
            alignItems: "center",
            backgroundColor: isSelected
              ? Colors.bubbleColor
              : isHovered
              ? "rgba(63, 123, 141, 0.05)"
              : "transparent",
            borderTopRightRadius: index === 0 ? 12 : 0,
            borderTopLeftRadius: index === 0 ? 12 : 0,
            borderBottomRightRadius: isLast ? 12 : 0,
            borderBottomLeftRadius: isLast ? 12 : 0,
            opacity: isHovered && isSelected ? 0.7 : 1,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <View
              style={{
                alignItems: "flex-start",
                // marginHorizontal: 10,
                width: "100%",
              }}
            >
              <Text
                style={{
                  color: isSelected ? Colors.whiteColor : Colors.blackColor,
                  fontSize: 16,
                }}
              >
                {client.nameForCoach} {client.surnameForCoach}
              </Text>
              <ClientWeekStatusText
                client={client}
                style={{
                  color: isSelected ? Colors.lightGrayColor : Colors.grayColor,
                  fontSize: 12,
                  marginTop: 2,
                }}
                showColorForUnprepared={isSelected ? false : true}
              />
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          />
          <View
            style={{
              //height: selectedClientName === client.name ? 2 : 1,
              backgroundColor: Colors.grayColor,
              // marginTop: 5,
            }}
          />
        </TouchableOpacity>
      );
    });
    return (
      <ScrollView
        style={{
          width: "100%",
        }}
        showsVerticalScrollIndicator={false}
      >
        {coach.getFilteredClientsInForm().length > 0 ? (
          <>
            {coach.getFilteredClientsInForm().map((client, index, array) => (
              <View key={client.id}>
                <ClientRow
                  client={client}
                  index={index}
                  isLast={index === array.length - 1}
                />
                {index < coach.getFilteredClientsInForm().length - 1 && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: Colors.borderColor,
                    }}
                  />
                )}
              </View>
            ))}
          </>
        ) : (
          <>
            <IconEmptyView
              iconLibrary={"Ionicons"}
              mainText={"emptyClientsTitle-string"}
              subText={"addNewClientsText-string"}
              iconName={"people-outline"}
              marginTop={32}
              marginBottom={16}
            />
          </>
        )}
      </ScrollView>
    );
  });

  const FormInfo = observer(() => {
    const [typeMenu, setTypeMenu] = useState(false);
    const showTypeMenu = () => setTypeMenu(true);

    const WeekDayPicker = observer(() => {
      const days = [
        "mondayLetter-string",
        "tuesdayLetter-string",
        "wednesdayLetter-string",
        "thursdayLetter-string",
        "fridayLetter-string",
        "saturdayLetter-string",
        "sundayLetter-string",
      ];

      const WeekDayButton = observer(({ day, idx }) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            style={[
              styles.dayCircle,
              {
                backgroundColor: isHovered
                  ? "rgba(63, 123, 141, 0.7)"
                  : coach.formDay === idx
                  ? "rgba(63, 123, 141, 1)"
                  : "rgba(63, 123, 141, 0.65)",
              },
            ]}
            onPress={() => coach.setProperty("formDay", idx)}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text style={styles.dayText}>{t(day)}</Text>
          </TouchableOpacity>
        );
      });

      return (
        coach.formType === "Semanal" && (
          <View
            style={[
              styles.weekDayContainer,
              { width: screenSize === "medium" ? "70%" : "100%" },
            ]}
          >
            {days.map((day, idx) => (
              <WeekDayButton day={day} idx={idx} key={idx} />
            ))}
          </View>
        )
      );
    });

    const TypeMenu = () => {
      const [isHovered, setIsHovered] = useState(false);
      const MenuItmView = ({ idx }) => {
        const [isHovered, setIsHovered] = useState(false);

        return idx === 1 ? (
          <MenuItem
            onPress={() => {
              // setFormType("Semanal");
              coach.setProperty("formType", "Semanal");
              setTypeMenu(false);
            }}
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered && "600",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {t("weeklyFormType-string")}
          </MenuItem>
        ) : (
          <MenuItem
            onPress={() => {
              coach.setProperty("formType", "Fin de bloque");
              setTypeMenu(false);
            }}
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered && "600",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {t("blockFormType-string")}
          </MenuItem>
        );
      };
      return (
        <Menu
          visible={typeMenu}
          anchor={
            <TouchableOpacity
              onPress={showTypeMenu}
              style={{
                flexDirection: "row",
                alignItems: "center",
                opacity: isHovered ? 0.5 : 1,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text style>{coach.formTypeLocalized(t)}</Text>
              <View>
                <MaterialIcons
                  name="keyboard-arrow-up"
                  size={15}
                  color={Colors.blackColor}
                  style={{ paddingHorizontal: 4, marginBottom: -4 }}
                />
                <MaterialIcons
                  name="keyboard-arrow-down"
                  size={15}
                  color={Colors.blackColor}
                  style={{ paddingHorizontal: 4, marginTop: -4 }}
                />
              </View>
            </TouchableOpacity>
          }
          style={GlobalStyles.menu}
          onRequestClose={() => setTypeMenu(false)}
        >
          <MenuItmView idx={1} />
          <MenuItmView idx={2} />
        </Menu>
      );
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
      <View
        style={{
          width: screenSize != "large" ? "100%" : "28%",
          alignItems: "center",
          paddingHorizontal: screenSize != "large" ? 0 : 16,
          paddingVertical: 20,
        }}
      >
        {!form && <Text style={Fonts.bold16}>{t(text)}</Text>}
        <TextInput
          style={[
            GlobalStyles.textInputStyle,
            {
              marginTop: 20,
              borderRadius: 14,
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
            },
          ]}
          placeholder={predefinedText}
          placeholderTextColor={Colors.grayColor}
          value={coach.formName}
          onChangeText={(text) => coach.setProperty("formName", text)}
          maxLength={45}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />

        <View
          style={[
            GlobalStyles.HStack,
            {
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              marginTop: 16,
            },
          ]}
        >
          <Text style={[Fonts.medium14, {}]}>{t("typeDots-string")}</Text>
          {form ? <Text>{form.typeLocalized(t)}</Text> : <TypeMenu />}
        </View>

        <WeekDayPicker />

        <View
          style={{
            width: "100%",
            backgroundColor: Colors.borderColor,
            height: 1,
            alignSelf: "center",
            marginVertical: 20,
          }}
        />

        {form && form.type === "Inicial" ? (
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              marginBottom: screenSize !== "large" ? 20 : 0,
            }}
          >
            <Text
              style={{
                textAlign: "center",
                color: "gray",
                marginBottom: 30,
              }}
            >
              {t("initialFormText1-string")}
            </Text>
            <Text style={{ textAlign: "center", color: "gray" }}>
              {t("initialFormText2-string")}
            </Text>
          </View>
        ) : (
          <>
            {screenSize === "large" && (
              <>
                <View style={{ marginBottom: 8, width: "100%" }}>
                  <SearchBar
                    text={coach.searchTermClientsInForm}
                    onChangeText={(text) =>
                      coach.setProperty("searchTermClientsInForm", text)
                    }
                    placeholder={"searchClient-string"}
                    maxWidth={260}
                  />
                </View>

                <SelectAllButton />
                <ClientsList />
              </>
            )}
          </>
        )}
      </View>
    );
  });

  const SectionBlock = observer(({ section, idx }) => {
    const QuestionRow = observer(({ question, index }) => {
      const [typeMenu, setTypeMenu] = useState(false);
      const showTypeMenu = () => setTypeMenu(true);

      const TypeMenu = () => {
        const MenuItemView = ({ idx }) => {
          const [isHovered, setIsHovered] = useState(false);

          return idx === 1 ? (
            <MenuItem
              onPress={() => {
                question.setProperty("type", "Texto");
                setTypeMenu(false);
              }}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("questionTextType-string")}
            </MenuItem>
          ) : (
            <MenuItem
              onPress={() => {
                question.setProperty("type", "Número");
                setTypeMenu(false);
              }}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("questionNumberType-string")}
            </MenuItem>
          );
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
          <Menu
            visible={typeMenu}
            anchor={
              <TouchableOpacity
                onPress={showTypeMenu}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 4,
                  marginBottom: 2,
                  opacity: isHovered ? 0.5 : 1,
                }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Text style={{ marginBottom: 1 }}>
                  {question.typeLocalized(t)}
                </Text>
                <View>
                  <MaterialIcons
                    name="keyboard-arrow-up"
                    size={15}
                    color={Colors.blackColor}
                    style={{ paddingHorizontal: 4, marginBottom: -4 }}
                  />
                  <MaterialIcons
                    name="keyboard-arrow-down"
                    size={15}
                    color={Colors.blackColor}
                    style={{ paddingHorizontal: 4, marginTop: -4 }}
                  />
                </View>
              </TouchableOpacity>
            }
            style={GlobalStyles.menu}
            onRequestClose={() => setTypeMenu(false)}
          >
            <MenuItemView idx={1} />
            <MenuItemView idx={2} />
          </Menu>
        );
      };

      const DeleteQuestionButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => question.section.deleteQuestion(question)}
            disabled={section.questions.length === 1}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Ionicons
              name={
                isHovered && section.questions.length > 1
                  ? "trash"
                  : "trash-outline"
              }
              size={20}
              color={"red"}
              style={{
                paddingLeft: 10,
                opacity: section.questions.length === 1 ? 0.5 : 1,
              }}
            />
          </TouchableOpacity>
        );
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        question && (
          <View
            style={{
              width: "100%",
              borderLeftWidth: 5,
              borderColor: "gray",
              borderLeftColor: Colors.bubbleColor,
              borderRadius: 5,
              paddingLeft: 8,
              marginTop: index !== 0 ? 10 : 0,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              <TextInput
                style={[
                  styles.questionInputStyle,
                  {
                    fontSize: screenSize === "large" ? 14 : 12,
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={t("questionPlaceholderText-string")}
                placeholderTextColor={Colors.grayColor}
                value={question.question}
                onChangeText={(text) => question.setProperty("question", text)}
                multiline={true}
                numberOfLines={screenSize === "large" ? 2 : 3}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
              <DeleteQuestionButton />
            </View>
            <TypeMenu />
          </View>
        )
      );
    });
    const DeleteSectionButton = () => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={() => coach.deleteFormSection(section)}
          style={{
            alignSelf: "center",
            flexDirection: "row",
            borderWidth: 1,
            borderColor: Colors.redColor,
            borderRadius: 12,
            paddingVertical: 6,
            paddingHorizontal: 8,
            alignItems: "center",
            backgroundColor: isHovered ? Colors.redColor : "transparent",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Text
            style={{
              fontSize: 12,
              color: isHovered ? Colors.whiteColor : Colors.redColor,
            }}
          >
            {t("deleteSection-string")}
          </Text>
        </TouchableOpacity>
      );
    };
    return (
      <View style={{ marginBottom: 15 }}>
        {idx !== 0 && <View style={styles.sectionSeparator} />}
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          <TextInput
            style={styles.sectionInputStyle}
            placeholder={t("nameOfSection-string")}
            placeholderTextColor={Colors.grayColor}
            value={section.name}
            onChangeText={(text) => section.setProperty("name", text)}
            maxLength={45}
          />
          {coach.formSections.length > 1 && <DeleteSectionButton />}
        </View>

        {section.questions &&
          section.questions.map((question, index) => (
            <QuestionRow question={question} key={index} />
          ))}
        <AddQuestionButton section={section} />
      </View>
    );
  });

  const AddQuestionButton = ({ section }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => section.addQuestion()}
        style={{
          alignSelf: "flex-start",
          marginTop: 10,
          flexDirection: "row",
          borderWidth: 1,
          borderColor: Colors.grayColor,
          borderRadius: 12,
          paddingVertical: 4,
          paddingHorizontal: 8,
          borderStyle: "dashed",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AntDesign name="plus" size={16} color={Colors.blackColor} />
        <Text
          style={{
            marginLeft: 4,
            fontWeight: isHovered ? "500" : "normal",
          }}
        >
          {t("addQuestion-string")}
        </Text>
      </TouchableOpacity>
    );
  };

  const AddSectionButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => coach.addFormSection()}
        style={{
          alignSelf: "center",
          marginVertical: 15,
          flexDirection: "row",
          borderWidth: 1,
          borderRadius: 14,
          paddingVertical: 6,
          paddingHorizontal: 8,
          alignItems: "center",
          borderStyle: "dashed",
          borderColor: Colors.grayColor,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AntDesign name="plus" size={18} />
        <Text
          style={{
            marginLeft: 4,
            // fontWeight: "500",
            fontSize: 16,
            fontWeight: isHovered ? "500" : "normal",
          }}
        >
          {t("addSection-string")}
        </Text>
      </TouchableOpacity>
    );
  };

  const SelectAllButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => {
          coach.activeClients.forEach((client) => {
            if (!coach.formSelectedClients.includes(client)) {
              coach.formSelectedClients.push(client);
            }
          });
          coach.setProperty("searchTermClientsInForm", "");
        }}
        style={{ width: "100%", marginBottom: 10 }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Text
          style={{
            alignSelf: "flex-start",
            color: Colors.bubbleColor,
            fontWeight: isHovered ? "500" : "normal",
          }}
        >
          {t("selectAll-string")}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <View style={GlobalStyles.touchableBackground} />
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              maxHeight: "90%",
              minHeight: screenSize != "large" ? 200 : 500,
              padding: screenSize === "small" ? 8 : 24,
              width: screenSize === "small" && "90%",
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          <HeaderButtons />

          {screenSize != "large" ? (
            <ScrollView
              style={{
                flex: 1,
                flexDirection: screenSize != "large" ? "column" : "row",
                borderWidth: screenSize != "large" ? 0 : 1,
                borderRadius: screenSize != "large" ? 0 : 16,
                borderColor: Colors.borderColor,
                maxWidth: screenSize != "large" ? 500 : 1000,
                minWidth: screenSize === "medium" ? 500 : 250,
              }}
              contentContainerStyle={{
                height: "100%",
              }}
              showsVerticalScrollIndicator={false}
            >
              <View
                style={{
                  height: "100%",
                }}
              >
                <FormInfo />
                {coach.formSections &&
                  coach.formSections.map((section, index) => (
                    <SectionBlock section={section} idx={index} key={index} />
                  ))}
                <AddSectionButton />
                {form ? (
                  <>
                    {form.type !== "Inicial" && (
                      <>
                        <View
                          style={{
                            width: "100%",
                            backgroundColor: Colors.borderColor,
                            height: 1,
                            alignSelf: "center",
                            marginVertical: 20,
                          }}
                        />
                        <View style={{ marginBottom: 8, width: "100%" }}>
                          <SearchBar
                            text={coach.searchTermClientsInForm}
                            onChangeText={(text) =>
                              coach.setProperty("searchTermClientsInForm", text)
                            }
                            placeholder={"searchClient-string"}
                            maxWidth={260}
                          />
                        </View>
                        <SelectAllButton />
                        <ClientsList />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <View
                      style={{
                        width: "100%",
                        backgroundColor: Colors.borderColor,
                        height: 1,
                        alignSelf: "center",
                        marginVertical: 20,
                      }}
                    />
                    <View style={{ marginBottom: 8, width: "100%" }}>
                      <SearchBar
                        text={coach.searchTermClientsInForm}
                        onChangeText={(text) =>
                          coach.setProperty("searchTermClientsInForm", text)
                        }
                        placeholder={"searchClient-string"}
                        maxWidth={260}
                      />
                    </View>
                    <SelectAllButton />
                    <ClientsList />
                  </>
                )}
              </View>
            </ScrollView>
          ) : (
            <View
              style={{
                flexDirection: screenSize != "large" ? "column" : "row",
                flex: 1,
                minWidth: 1000,
                height: "100%",
                borderRadius: 16,
                borderWidth: 1,
                borderColor: Colors.borderColor,
                justifyContent: "space-between",
              }}
            >
              <FormInfo />
              <View
                style={{
                  width: 1,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <View
                  style={{
                    width: 1,
                    height: "90%",
                    backgroundColor: Colors.borderColor,
                    flexShrink: 0,
                  }}
                />
              </View>

              <View
                style={{
                  flex: 1,
                  padding: 10,
                }}
              >
                <ScrollView
                  style={{
                    marginHorizontal: screenSize != "large" ? 4 : 0,
                  }}
                  contentContainerStyle={{ height: "100%" }}
                  showsVerticalScrollIndicator={false}
                >
                  {coach.formSections &&
                    coach.formSections.map((section, index) => (
                      <SectionBlock section={section} idx={index} key={index} />
                    ))}
                  <AddSectionButton />
                </ScrollView>
              </View>
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  questionInputStyle: {
    width: "100%",
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 8,
    borderRadius: 10,
    outlineStyle: "none",
  },
  sectionInputStyle: {
    width: "100%",
    color: Colors.blackColor,
    outlineStyle: "none",
    paddingVertical: 4,
    fontWeight: "600",
  },
  weekDayContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 16,
  },
  dayCircle: {
    width: 25,
    height: 25,
    borderRadius: 20,
    backgroundColor: "#3F7B8D", // Example color, replace with desired color
    justifyContent: "center",
    alignItems: "center",
  },
  dayText: {
    color: "white",
    fontSize: 11,
    fontWeight: "bold",
  },
  sectionSeparator: {
    width: "95%",
    backgroundColor: Colors.borderColor,
    height: 1,
    alignSelf: "center",
    marginBottom: 15,
  },
});

export default AddFormView;
